__webpack_require__.p = "https://ikea.marat.qd.je/at/de/customer-service/support/";